import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
// import Vue from 'vue'
let BcToast = class BcToast extends Vue {
    constructor() {
        super(...arguments);
        this.visible = false;
        this.text = '';
        this.x = '';
        this.y = 'top';
        this.timeout = 6000;
        this.color = '';
        this.vertical = true;
        this.positiveButtonText = '关闭';
    }
    open(op) {
        const that = this;
        const text = typeof op === 'object' ? op['text'] : op;
        if (!text)
            return console.log('text is argument is required.');
        that.text = text;
        that.color = op && op['color'] || 'info';
        that.timeout = Number(op && (op['timeout'] || op['duration']) || '3000');
        that.x = op && op['x'] || '';
        that.y = op && op['y'] || 'top';
        that.vertical = /undefined|null/i.test(op && op['vertical']) ? true : (op && op['vertical']);
        that.visible = true;
    }
    info(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'grey',
        });
    }
    success(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'success',
        });
    }
    error(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'error',
        });
    }
    warn(itext, itimeout) {
        this.open({
            text: itext,
            timeout: itimeout,
            color: 'orange lighten-1',
        });
    }
};
BcToast = __decorate([
    Component({
        name: 'BcToast',
        data: () => ({
        // visible: false,
        // text: '',
        // x: '',
        // y: 'top',
        // timeout: 6000,
        // color: '',
        // vertical: true,
        // positiveButtonText: '关闭',
        }),
        // @ts-ignore
        methods: {},
    })
], BcToast);
export default BcToast;
